// src/tiptap/ResizableImage.js

import { Node, mergeAttributes } from '@tiptap/core';
import { NodeViewWrapper, ReactNodeViewRenderer } from '@tiptap/react';
import { Rnd } from 'react-rnd';

/* React component for NodeView */
const ResizableImageComponent = ({ node, updateAttributes }) => (
    <NodeViewWrapper className="resizable-image">
        <Rnd
            size={{ width: node.attrs.width, height: node.attrs.height }}
            lockAspectRatio
            enableResizing={{ bottomRight: true }}
            disableDragging
            bounds="parent"
            style={{ position: 'relative', display: 'inline-block' }}
            resizeHandleComponent={{
                bottomRight: <div className="resize-handle" />,  // 수동 핸들
            }}
            onResizeStop={(_, __, ref) => {
                updateAttributes({
                    width: ref.offsetWidth,
                    height: ref.offsetHeight,
                });
            }}
        >
            <img
                src={node.attrs.src}
                alt={node.attrs.alt}
                style={{ width: '100%', height: '100%', display: 'block' }}
            />
        </Rnd>
    </NodeViewWrapper>
);

export const ResizableImage = Node.create({
    name: 'resizableImage',
    group: 'block',
    inline: false,
    atom: true,

    addAttributes() {
        return {
            src: {},
            alt: { default: null },
            width: { default: 300 },
            height: { default: 300 },
        };
    },

    parseHTML() {
        return [{ tag: 'img[data-type="resizable-image"]' }];
    },

    renderHTML({ HTMLAttributes }) {
        return [
            'img',
            mergeAttributes({ 'data-type': 'resizable-image' }, HTMLAttributes),
        ];
    },

    addNodeView() {
        return ReactNodeViewRenderer(ResizableImageComponent);
    },
});